import { useState } from "react";

import { issueStatuses } from "@/features/project-management/data";
import { ProjectIssuesTable } from "@/features/project-management/hooks/use-project-issues-table";
import { ColumnId } from "@/features/project-management/types";
import { IssueStatus } from "@/generated/graphql";

import { FilterCombobox } from "../../filter-combobox";
import { SearchMultiSelectItem } from "../../filter-combobox/filter-combobox";

export const IssueStatusFilter = ({ table }: { table: ProjectIssuesTable }) => {
  const column = table.getColumn(ColumnId.Status);

  const committed = (column?.getFilterValue() ?? []) as IssueStatus[];

  const items: SearchMultiSelectItem[] = issueStatuses.map((status) => ({
    value: status.toString(),
    label: status.toString().replace("_", " ").toUpperCase(),
  }));

  const [selected, setSelected] = useState<string[]>(
    committed.map((s) => s.toString())
  );

  const handleApply = () => {
    column?.setFilterValue(selected as IssueStatus[]);
  };

  const handleClear = () => {
    setSelected([]);
    column?.setFilterValue([]);
  };

  return (
    <FilterCombobox
      items={items}
      title="Status"
      isSearchable={false}
      selectedItemIds={selected}
      onSelectedChange={setSelected}
      onApply={handleApply}
      onClear={handleClear}
      withIcon={false}
      withAvatar={false}
    />
  );
};
